//vuex的执行顺序是，this.$store.dispatch()触发 actions中的方法，acitons中的方法触发mutations中的方法，mutations中的方法操作state中的数据。
// 创建人：董文英
// 创建时间 ：20230221
// 模块名称：存储
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
var store = new Vuex.Store({
  state: { //在state对象建立需要数据这里放全局参数
    menus: [],
    // activemenu: ""
  },
  mutations: {
    //这里是set方法
    ADD_ROUTES: (state, data) => {
      // console.log("ADD_ROUTES——state", state)
      state.menus = data;
      // console.log("ADD_ROUTES", state.menus);
      localStorage.setItem('menus', JSON.stringify(data));
    },
    // ACTIVE_MENU(state, data) => {
    //   state.activemenu = data;
    //   localStorage.setItem('activemenu', JSON.stringify(data));
    // },
  },
  getters: {
    //这里是get方法,并且每次打开浏览器优先执行该方法，获取所有的状态
    getMenus: state => state.menus
  },
  actions: {
    // 处理state的方法体
    addroutes(context, data) {
      context.commit("ADD_ROUTES", data)
    }
  },

})
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js